import { useMemo } from "react"

import { ECampaignType, EFolderAssets } from "@/modules/helpers/enum"
import type { SubmissionCampaign } from "@/modules/types"

export function useCampaignData(submission?: SubmissionCampaign) {
  return useMemo(() => {
    if (submission?.campaigns) {
      return {
        campaign: submission.campaigns,
        campaignType: ECampaignType.REVIEW_PRODUCT,
        folderAssets: EFolderAssets.THUMBNAIL_CAMPAIGN
      }
    }
    if (submission?.costPerViewCampaigns) {
      return {
        campaign: submission.costPerViewCampaigns,
        campaignType: ECampaignType.COST_PER_VIEW,
        folderAssets: EFolderAssets.THUMBNAIL_CAMPAIGN
      }
    }
    return {
      campaign: submission?.affCampaigns,
      campaignType: ECampaignType.AFFILIATE,
      folderAssets: EFolderAssets.THUMBNAIL_AFFILIATE_CAMPAIGN
    }
  }, [submission])
}
